"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldMiningColony = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const DiscardCards_1 = require("../../deferredActions/DiscardCards");
class OldMiningColony extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.OLD_MINING_COLONY,
            tags: [Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'P55',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.titanium(1));
                    b.colonies(1).minus().cards(1);
                }),
                description: 'Increase your titanium production 1 step. Place a colony. Discard 1 card.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build colony'));
        player.game.defer(new DiscardCards_1.DiscardCards(player));
        return undefined;
    }
}
exports.OldMiningColony = OldMiningColony;
//# sourceMappingURL=OldMiningColony.js.map